import type { ProductSurveyQuestion } from '@app/_proto/Protos/product_surveys';
import { TextField } from '@mui/material';

export type SurveyAnswerNumberProps = {
    question: ProductSurveyQuestion;
    onAnswer: (questionId: string, answer: string) => void;
};

export default function SurveyAnswerNumber({ question, onAnswer }: SurveyAnswerNumberProps) {
    const onValueChanged = (newValue: string) => {
        if (newValue === '') {
            //Remove from answer list, if user has removed the answer
            onAnswer(question.id, '');
        } else {
            const newData = JSON.stringify({ value: Number.parseFloat(newValue) });
            onAnswer(question.id, newData);
        }
    };

    return (
        <>
            <TextField
                type="number"
                className="w-full"
                inputProps={{
                    className: 'py-10',
                }}
                variant="outlined"
                onBlur={e => onValueChanged(e.target.value.trim())}
            />
        </>
    );
}
